"use client";

import { Button } from "@faire/slate/components/button";
import { getTypedChildren } from "@faire/slate/lib/getTypedChildren";
import React from "react";

import { MODAL_FOOTER_MAX_BUTTON_QTY as MAX_BUTTON_QTY } from "./consts";

export const ModalButtons: React.FC<
  React.PropsWithChildren<{ primaryAsDestructive?: boolean }>
> = ({ children, primaryAsDestructive }) => {
  const [{ buttons }, rest] = getTypedChildren(children, {
    buttons: Button,
  });

  if (rest.length > 0) {
    // oxlint-disable-next-line no-console
    console.error(
      "Footer accepts only Button as children when variant is not customSlot."
    );
  }

  if (buttons.length === 0) {
    // oxlint-disable-next-line no-console
    console.error("Footer requires at least one button");
  } else {
    const firstButtonVariant = buttons[0]?.props?.variant;
    if (firstButtonVariant && firstButtonVariant !== "primary") {
      // oxlint-disable-next-line no-console
      console.error("Footer's first button must be primary");
    }
  }

  if (buttons.length > MAX_BUTTON_QTY) {
    // oxlint-disable-next-line no-console
    console.error(
      "Footer accepts only up to 3 buttons when variant is not customSlot."
    );
  }

  return buttons.slice(0, MAX_BUTTON_QTY).map((button, index) =>
    button.props.variant !== "plain" ? (
      <Button
        {...button.props}
        key={button.props.variant ?? index}
        destructive={primaryAsDestructive && button.props.variant === "primary"}
      />
    ) : (
      <div className="flex self-center" key={button.props.variant ?? index}>
        <Button {...button.props} />
      </div>
    )
  );
};
